import { api } from './index';
import type { ClinicalAuthor } from '../utils/clinical-author';
import type { ClinicalVoidable } from '../utils/clinical-void';

export type Note = ClinicalVoidable & {
  id: number;
  text: string;
  userEmail: string;
  createdAgo: string;
  edited: boolean;
  humanCreatedAt: string;
  author: ClinicalAuthor | null;
}

export interface NoteForm {
  text: string;
  noteableId: number;
  noteableType: string;
}

const BASE_PATH = '/api/internal';

export const notesApi = {
  index(noteableType: string, noteableId: number): Promise<Array<Note>> {
    return api({
      method: 'get',
      url: `${BASE_PATH}/${noteableType.toLowerCase()}s/${noteableId}/notes`,
    }).then(response => response.data.notes);
  },
  create(noteForm: NoteForm): Promise<Note> {
    return api({
      method: 'post',
      url: `${BASE_PATH}/${noteForm.noteableType.toLowerCase()}s/${noteForm.noteableId}/notes`,
      data: {
        note: {
          text: noteForm.text,
        },
      },
    }).then(response => response.data.note);
  },
};
